/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BetslipRouteImport } from './routes/betslip'
import { Route as BetzoneRouteImport } from './routes/betzone'
import { Route as BookedticketRouteImport } from './routes/bookedticket'
import { Route as CasinoRouteImport } from './routes/casino'
import { Route as ForgotpasswordRouteImport } from './routes/forgotpassword'
import { Route as LiveRouteImport } from './routes/live'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as PokerRouteImport } from './routes/poker'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PromotionsRouteImport } from './routes/promotions'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetpasswordRouteImport } from './routes/resetpassword'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as SportsRouteImport } from './routes/sports'
import { Route as UiKitRouteImport } from './routes/ui-kit'
import { Route as VirtualsportsRouteImport } from './routes/virtualsports'
import { Route as CasinoIndexRouteImport } from './routes/casino.index'
import { Route as CasinoCategoryRouteImport } from './routes/casino.$category'
import { Route as CasinoProvidersRouteImport } from './routes/casino.providers'
import { Route as LiveIndexRouteImport } from './routes/live.index'
import { Route as LiveEventIdRouteImport } from './routes/live.$eventId'
import { Route as LivecasinoIndexRouteImport } from './routes/livecasino.index'
import { Route as PageSlugRouteImport } from './routes/page.$slug'
import { Route as ProfileIndexRouteImport } from './routes/profile.index'
import { Route as ProfileBonusesRouteImport } from './routes/profile.bonuses'
import { Route as ProfileClaimbonusRouteImport } from './routes/profile.claimbonus'
import { Route as ProfileDepositLimitsRouteImport } from './routes/profile.deposit-limits'
import { Route as ProfileDepositsRouteImport } from './routes/profile.deposits'
import { Route as ProfileDetailsRouteImport } from './routes/profile.details'
import { Route as ProfileKycRouteImport } from './routes/profile.kyc'
import { Route as ProfileMessagesRouteImport } from './routes/profile.messages'
import { Route as ProfileSelfExclusionRouteImport } from './routes/profile.self-exclusion'
import { Route as ProfileSettingsRouteImport } from './routes/profile.settings'
import { Route as ProfileTicketsRouteImport } from './routes/profile.tickets'
import { Route as ProfileTransactionsRouteImport } from './routes/profile.transactions'
import { Route as ProfileWithdrawalsRouteImport } from './routes/profile.withdrawals'
import { Route as PromotionsIndexRouteImport } from './routes/promotions.index'
import { Route as PromotionsSlugRouteImport } from './routes/promotions.$slug'
import { Route as RegisterIndexRouteImport } from './routes/register.index'
import { Route as ResetpasswordIndexRouteImport } from './routes/resetpassword.index'
import { Route as ResetpasswordGuidRouteImport } from './routes/resetpassword.$guid'
import { Route as SportsIndexRouteImport } from './routes/sports.index'
import { Route as VerifyemailTokenRouteImport } from './routes/verifyemail.$token'
import { Route as CasinoCategoryIndexRouteImport } from './routes/casino.$category.index'
import { Route as CasinoCategoryVendorRouteImport } from './routes/casino.$category.$vendor'
import { Route as ProfileBonusesIndexRouteImport } from './routes/profile.bonuses.index'
import { Route as ProfileDepositsIndexRouteImport } from './routes/profile.deposits.index'
import { Route as ProfileDepositsProviderIdRouteImport } from './routes/profile.deposits.$providerId'
import { Route as ProfileMessagesIndexRouteImport } from './routes/profile.messages.index'
import { Route as ProfileMessagesMessageIdRouteImport } from './routes/profile.messages.$messageId'
import { Route as ProfileWithdrawalsIndexRouteImport } from './routes/profile.withdrawals.index'
import { Route as ProfileWithdrawalsProviderIdRouteImport } from './routes/profile.withdrawals.$providerId'
import { Route as RegisterItemTokenRouteImport } from './routes/register.$item.$token'
import { Route as ResetpasswordGuidIndexRouteImport } from './routes/resetpassword.$guid.index'
import { Route as ResetpasswordGuidChannelRouteImport } from './routes/resetpassword.$guid.$channel'
import { Route as SportsSportIndexRouteImport } from './routes/sports.$sport.index'
import { Route as SportsSportFavoritesRouteImport } from './routes/sports.$sport.favorites'
import { Route as SportsSportLastminuteRouteImport } from './routes/sports.$sport.lastminute'
import { Route as SportsSportTodayRouteImport } from './routes/sports.$sport.today'
import { Route as SportsSportTopeventsRouteImport } from './routes/sports.$sport.topevents'
import { Route as ProfileBonusesBonusTypeBonusIdRouteImport } from './routes/profile.bonuses.$bonusType.$bonusId'
import { Route as SportsSportCategoryIndexRouteImport } from './routes/sports.$sport.$category.index'
import { Route as CasinoCategoryProviderVendorGameTagRouteImport } from './routes/casino.$category.$provider.$vendor.$gameTag'
import { Route as SportsSportCategoryTournamentIndexRouteImport } from './routes/sports.$sport.$category.$tournament.index'
import { Route as SportsSportCategoryTournamentEventIdRouteImport } from './routes/sports.$sport.$category.$tournament.$eventId'
import { Route as SportsSportCategoryTournamentOutrightsRouteImport } from './routes/sports.$sport.$category.$tournament.outrights'
import { Route as CasinoCategoryProviderVendorGameTagNameRouteImport } from './routes/casino.$category.$provider.$vendor.$gameTag.$name'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BetslipRoute = BetslipRouteImport.update({
  id: '/betslip',
  path: '/betslip',
  getParentRoute: () => rootRouteImport,
} as any)
const BetzoneRoute = BetzoneRouteImport.update({
  id: '/betzone',
  path: '/betzone',
  getParentRoute: () => rootRouteImport,
} as any)
const BookedticketRoute = BookedticketRouteImport.update({
  id: '/bookedticket',
  path: '/bookedticket',
  getParentRoute: () => rootRouteImport,
} as any)
const CasinoRoute = CasinoRouteImport.update({
  id: '/casino',
  path: '/casino',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotpasswordRoute = ForgotpasswordRouteImport.update({
  id: '/forgotpassword',
  path: '/forgotpassword',
  getParentRoute: () => rootRouteImport,
} as any)
const LiveRoute = LiveRouteImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerRoute = PartnerRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => rootRouteImport,
} as any)
const PokerRoute = PokerRouteImport.update({
  id: '/poker',
  path: '/poker',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PromotionsRoute = PromotionsRouteImport.update({
  id: '/promotions',
  path: '/promotions',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetpasswordRoute = ResetpasswordRouteImport.update({
  id: '/resetpassword',
  path: '/resetpassword',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsRoute = ResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => rootRouteImport,
} as any)
const SportsRoute = SportsRouteImport.update({
  id: '/sports',
  path: '/sports',
  getParentRoute: () => rootRouteImport,
} as any)
const UiKitRoute = UiKitRouteImport.update({
  id: '/ui-kit',
  path: '/ui-kit',
  getParentRoute: () => rootRouteImport,
} as any)
const VirtualsportsRoute = VirtualsportsRouteImport.update({
  id: '/virtualsports',
  path: '/virtualsports',
  getParentRoute: () => rootRouteImport,
} as any)
const CasinoIndexRoute = CasinoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CasinoRoute,
} as any)
const CasinoCategoryRoute = CasinoCategoryRouteImport.update({
  id: '/$category',
  path: '/$category',
  getParentRoute: () => CasinoRoute,
} as any)
const CasinoProvidersRoute = CasinoProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => CasinoRoute,
} as any)
const LiveIndexRoute = LiveIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LiveRoute,
} as any)
const LiveEventIdRoute = LiveEventIdRouteImport.update({
  id: '/$eventId',
  path: '/$eventId',
  getParentRoute: () => LiveRoute,
} as any)
const LivecasinoIndexRoute = LivecasinoIndexRouteImport.update({
  id: '/livecasino/',
  path: '/livecasino/',
  getParentRoute: () => rootRouteImport,
} as any)
const PageSlugRoute = PageSlugRouteImport.update({
  id: '/page/$slug',
  path: '/page/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileBonusesRoute = ProfileBonusesRouteImport.update({
  id: '/bonuses',
  path: '/bonuses',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileClaimbonusRoute = ProfileClaimbonusRouteImport.update({
  id: '/claimbonus',
  path: '/claimbonus',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileDepositLimitsRoute = ProfileDepositLimitsRouteImport.update({
  id: '/deposit-limits',
  path: '/deposit-limits',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileDepositsRoute = ProfileDepositsRouteImport.update({
  id: '/deposits',
  path: '/deposits',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileDetailsRoute = ProfileDetailsRouteImport.update({
  id: '/details',
  path: '/details',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileKycRoute = ProfileKycRouteImport.update({
  id: '/kyc',
  path: '/kyc',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileMessagesRoute = ProfileMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileSelfExclusionRoute = ProfileSelfExclusionRouteImport.update({
  id: '/self-exclusion',
  path: '/self-exclusion',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileSettingsRoute = ProfileSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileTicketsRoute = ProfileTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileTransactionsRoute = ProfileTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileWithdrawalsRoute = ProfileWithdrawalsRouteImport.update({
  id: '/withdrawals',
  path: '/withdrawals',
  getParentRoute: () => ProfileRoute,
} as any)
const PromotionsIndexRoute = PromotionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PromotionsRoute,
} as any)
const PromotionsSlugRoute = PromotionsSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => PromotionsRoute,
} as any)
const RegisterIndexRoute = RegisterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RegisterRoute,
} as any)
const ResetpasswordIndexRoute = ResetpasswordIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ResetpasswordRoute,
} as any)
const ResetpasswordGuidRoute = ResetpasswordGuidRouteImport.update({
  id: '/$guid',
  path: '/$guid',
  getParentRoute: () => ResetpasswordRoute,
} as any)
const SportsIndexRoute = SportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SportsRoute,
} as any)
const VerifyemailTokenRoute = VerifyemailTokenRouteImport.update({
  id: '/verifyemail/$token',
  path: '/verifyemail/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CasinoCategoryIndexRoute = CasinoCategoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CasinoCategoryRoute,
} as any)
const CasinoCategoryVendorRoute = CasinoCategoryVendorRouteImport.update({
  id: '/$vendor',
  path: '/$vendor',
  getParentRoute: () => CasinoCategoryRoute,
} as any)
const ProfileBonusesIndexRoute = ProfileBonusesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProfileBonusesRoute,
} as any)
const ProfileDepositsIndexRoute = ProfileDepositsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProfileDepositsRoute,
} as any)
const ProfileDepositsProviderIdRoute =
  ProfileDepositsProviderIdRouteImport.update({
    id: '/$providerId',
    path: '/$providerId',
    getParentRoute: () => ProfileDepositsRoute,
  } as any)
const ProfileMessagesIndexRoute = ProfileMessagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProfileMessagesRoute,
} as any)
const ProfileMessagesMessageIdRoute =
  ProfileMessagesMessageIdRouteImport.update({
    id: '/$messageId',
    path: '/$messageId',
    getParentRoute: () => ProfileMessagesRoute,
  } as any)
const ProfileWithdrawalsIndexRoute = ProfileWithdrawalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProfileWithdrawalsRoute,
} as any)
const ProfileWithdrawalsProviderIdRoute =
  ProfileWithdrawalsProviderIdRouteImport.update({
    id: '/$providerId',
    path: '/$providerId',
    getParentRoute: () => ProfileWithdrawalsRoute,
  } as any)
const RegisterItemTokenRoute = RegisterItemTokenRouteImport.update({
  id: '/$item/$token',
  path: '/$item/$token',
  getParentRoute: () => RegisterRoute,
} as any)
const ResetpasswordGuidIndexRoute = ResetpasswordGuidIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ResetpasswordGuidRoute,
} as any)
const ResetpasswordGuidChannelRoute =
  ResetpasswordGuidChannelRouteImport.update({
    id: '/$channel',
    path: '/$channel',
    getParentRoute: () => ResetpasswordGuidRoute,
  } as any)
const SportsSportIndexRoute = SportsSportIndexRouteImport.update({
  id: '/$sport/',
  path: '/$sport/',
  getParentRoute: () => SportsRoute,
} as any)
const SportsSportFavoritesRoute = SportsSportFavoritesRouteImport.update({
  id: '/$sport/favorites',
  path: '/$sport/favorites',
  getParentRoute: () => SportsRoute,
} as any)
const SportsSportLastminuteRoute = SportsSportLastminuteRouteImport.update({
  id: '/$sport/lastminute',
  path: '/$sport/lastminute',
  getParentRoute: () => SportsRoute,
} as any)
const SportsSportTodayRoute = SportsSportTodayRouteImport.update({
  id: '/$sport/today',
  path: '/$sport/today',
  getParentRoute: () => SportsRoute,
} as any)
const SportsSportTopeventsRoute = SportsSportTopeventsRouteImport.update({
  id: '/$sport/topevents',
  path: '/$sport/topevents',
  getParentRoute: () => SportsRoute,
} as any)
const ProfileBonusesBonusTypeBonusIdRoute =
  ProfileBonusesBonusTypeBonusIdRouteImport.update({
    id: '/$bonusType/$bonusId',
    path: '/$bonusType/$bonusId',
    getParentRoute: () => ProfileBonusesRoute,
  } as any)
const SportsSportCategoryIndexRoute =
  SportsSportCategoryIndexRouteImport.update({
    id: '/$sport/$category/',
    path: '/$sport/$category/',
    getParentRoute: () => SportsRoute,
  } as any)
const CasinoCategoryProviderVendorGameTagRoute =
  CasinoCategoryProviderVendorGameTagRouteImport.update({
    id: '/$provider/$vendor/$gameTag',
    path: '/$provider/$vendor/$gameTag',
    getParentRoute: () => CasinoCategoryRoute,
  } as any)
const SportsSportCategoryTournamentIndexRoute =
  SportsSportCategoryTournamentIndexRouteImport.update({
    id: '/$sport/$category/$tournament/',
    path: '/$sport/$category/$tournament/',
    getParentRoute: () => SportsRoute,
  } as any)
const SportsSportCategoryTournamentEventIdRoute =
  SportsSportCategoryTournamentEventIdRouteImport.update({
    id: '/$sport/$category/$tournament/$eventId',
    path: '/$sport/$category/$tournament/$eventId',
    getParentRoute: () => SportsRoute,
  } as any)
const SportsSportCategoryTournamentOutrightsRoute =
  SportsSportCategoryTournamentOutrightsRouteImport.update({
    id: '/$sport/$category/$tournament/outrights',
    path: '/$sport/$category/$tournament/outrights',
    getParentRoute: () => SportsRoute,
  } as any)
const CasinoCategoryProviderVendorGameTagNameRoute =
  CasinoCategoryProviderVendorGameTagNameRouteImport.update({
    id: '/$name',
    path: '/$name',
    getParentRoute: () => CasinoCategoryProviderVendorGameTagRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/betslip': typeof BetslipRoute
  '/betzone': typeof BetzoneRoute
  '/bookedticket': typeof BookedticketRoute
  '/casino': typeof CasinoRouteWithChildren
  '/forgotpassword': typeof ForgotpasswordRoute
  '/live': typeof LiveRouteWithChildren
  '/login': typeof LoginRoute
  '/partner': typeof PartnerRoute
  '/poker': typeof PokerRoute
  '/profile': typeof ProfileRouteWithChildren
  '/promotions': typeof PromotionsRouteWithChildren
  '/register': typeof RegisterRouteWithChildren
  '/resetpassword': typeof ResetpasswordRouteWithChildren
  '/results': typeof ResultsRoute
  '/sports': typeof SportsRouteWithChildren
  '/ui-kit': typeof UiKitRoute
  '/virtualsports': typeof VirtualsportsRoute
  '/casino/$category': typeof CasinoCategoryRouteWithChildren
  '/casino/providers': typeof CasinoProvidersRoute
  '/live/$eventId': typeof LiveEventIdRoute
  '/page/$slug': typeof PageSlugRoute
  '/profile/bonuses': typeof ProfileBonusesRouteWithChildren
  '/profile/claimbonus': typeof ProfileClaimbonusRoute
  '/profile/deposit-limits': typeof ProfileDepositLimitsRoute
  '/profile/deposits': typeof ProfileDepositsRouteWithChildren
  '/profile/details': typeof ProfileDetailsRoute
  '/profile/kyc': typeof ProfileKycRoute
  '/profile/messages': typeof ProfileMessagesRouteWithChildren
  '/profile/self-exclusion': typeof ProfileSelfExclusionRoute
  '/profile/settings': typeof ProfileSettingsRoute
  '/profile/tickets': typeof ProfileTicketsRoute
  '/profile/transactions': typeof ProfileTransactionsRoute
  '/profile/withdrawals': typeof ProfileWithdrawalsRouteWithChildren
  '/promotions/$slug': typeof PromotionsSlugRoute
  '/resetpassword/$guid': typeof ResetpasswordGuidRouteWithChildren
  '/verifyemail/$token': typeof VerifyemailTokenRoute
  '/casino/': typeof CasinoIndexRoute
  '/live/': typeof LiveIndexRoute
  '/livecasino/': typeof LivecasinoIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/promotions/': typeof PromotionsIndexRoute
  '/register/': typeof RegisterIndexRoute
  '/resetpassword/': typeof ResetpasswordIndexRoute
  '/sports/': typeof SportsIndexRoute
  '/casino/$category/$vendor': typeof CasinoCategoryVendorRoute
  '/profile/deposits/$providerId': typeof ProfileDepositsProviderIdRoute
  '/profile/messages/$messageId': typeof ProfileMessagesMessageIdRoute
  '/profile/withdrawals/$providerId': typeof ProfileWithdrawalsProviderIdRoute
  '/register/$item/$token': typeof RegisterItemTokenRoute
  '/resetpassword/$guid/$channel': typeof ResetpasswordGuidChannelRoute
  '/sports/$sport/favorites': typeof SportsSportFavoritesRoute
  '/sports/$sport/lastminute': typeof SportsSportLastminuteRoute
  '/sports/$sport/today': typeof SportsSportTodayRoute
  '/sports/$sport/topevents': typeof SportsSportTopeventsRoute
  '/casino/$category/': typeof CasinoCategoryIndexRoute
  '/profile/bonuses/': typeof ProfileBonusesIndexRoute
  '/profile/deposits/': typeof ProfileDepositsIndexRoute
  '/profile/messages/': typeof ProfileMessagesIndexRoute
  '/profile/withdrawals/': typeof ProfileWithdrawalsIndexRoute
  '/resetpassword/$guid/': typeof ResetpasswordGuidIndexRoute
  '/sports/$sport/': typeof SportsSportIndexRoute
  '/profile/bonuses/$bonusType/$bonusId': typeof ProfileBonusesBonusTypeBonusIdRoute
  '/sports/$sport/$category/': typeof SportsSportCategoryIndexRoute
  '/casino/$category/$provider/$vendor/$gameTag': typeof CasinoCategoryProviderVendorGameTagRouteWithChildren
  '/sports/$sport/$category/$tournament/$eventId': typeof SportsSportCategoryTournamentEventIdRoute
  '/sports/$sport/$category/$tournament/outrights': typeof SportsSportCategoryTournamentOutrightsRoute
  '/sports/$sport/$category/$tournament/': typeof SportsSportCategoryTournamentIndexRoute
  '/casino/$category/$provider/$vendor/$gameTag/$name': typeof CasinoCategoryProviderVendorGameTagNameRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/betslip': typeof BetslipRoute
  '/betzone': typeof BetzoneRoute
  '/bookedticket': typeof BookedticketRoute
  '/forgotpassword': typeof ForgotpasswordRoute
  '/login': typeof LoginRoute
  '/partner': typeof PartnerRoute
  '/poker': typeof PokerRoute
  '/results': typeof ResultsRoute
  '/ui-kit': typeof UiKitRoute
  '/virtualsports': typeof VirtualsportsRoute
  '/casino/providers': typeof CasinoProvidersRoute
  '/live/$eventId': typeof LiveEventIdRoute
  '/page/$slug': typeof PageSlugRoute
  '/profile/claimbonus': typeof ProfileClaimbonusRoute
  '/profile/deposit-limits': typeof ProfileDepositLimitsRoute
  '/profile/details': typeof ProfileDetailsRoute
  '/profile/kyc': typeof ProfileKycRoute
  '/profile/self-exclusion': typeof ProfileSelfExclusionRoute
  '/profile/settings': typeof ProfileSettingsRoute
  '/profile/tickets': typeof ProfileTicketsRoute
  '/profile/transactions': typeof ProfileTransactionsRoute
  '/promotions/$slug': typeof PromotionsSlugRoute
  '/verifyemail/$token': typeof VerifyemailTokenRoute
  '/casino': typeof CasinoIndexRoute
  '/live': typeof LiveIndexRoute
  '/livecasino': typeof LivecasinoIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/promotions': typeof PromotionsIndexRoute
  '/register': typeof RegisterIndexRoute
  '/resetpassword': typeof ResetpasswordIndexRoute
  '/sports': typeof SportsIndexRoute
  '/casino/$category/$vendor': typeof CasinoCategoryVendorRoute
  '/profile/deposits/$providerId': typeof ProfileDepositsProviderIdRoute
  '/profile/messages/$messageId': typeof ProfileMessagesMessageIdRoute
  '/profile/withdrawals/$providerId': typeof ProfileWithdrawalsProviderIdRoute
  '/register/$item/$token': typeof RegisterItemTokenRoute
  '/resetpassword/$guid/$channel': typeof ResetpasswordGuidChannelRoute
  '/sports/$sport/favorites': typeof SportsSportFavoritesRoute
  '/sports/$sport/lastminute': typeof SportsSportLastminuteRoute
  '/sports/$sport/today': typeof SportsSportTodayRoute
  '/sports/$sport/topevents': typeof SportsSportTopeventsRoute
  '/casino/$category': typeof CasinoCategoryIndexRoute
  '/profile/bonuses': typeof ProfileBonusesIndexRoute
  '/profile/deposits': typeof ProfileDepositsIndexRoute
  '/profile/messages': typeof ProfileMessagesIndexRoute
  '/profile/withdrawals': typeof ProfileWithdrawalsIndexRoute
  '/resetpassword/$guid': typeof ResetpasswordGuidIndexRoute
  '/sports/$sport': typeof SportsSportIndexRoute
  '/profile/bonuses/$bonusType/$bonusId': typeof ProfileBonusesBonusTypeBonusIdRoute
  '/sports/$sport/$category': typeof SportsSportCategoryIndexRoute
  '/casino/$category/$provider/$vendor/$gameTag': typeof CasinoCategoryProviderVendorGameTagRouteWithChildren
  '/sports/$sport/$category/$tournament/$eventId': typeof SportsSportCategoryTournamentEventIdRoute
  '/sports/$sport/$category/$tournament/outrights': typeof SportsSportCategoryTournamentOutrightsRoute
  '/sports/$sport/$category/$tournament': typeof SportsSportCategoryTournamentIndexRoute
  '/casino/$category/$provider/$vendor/$gameTag/$name': typeof CasinoCategoryProviderVendorGameTagNameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/betslip': typeof BetslipRoute
  '/betzone': typeof BetzoneRoute
  '/bookedticket': typeof BookedticketRoute
  '/casino': typeof CasinoRouteWithChildren
  '/forgotpassword': typeof ForgotpasswordRoute
  '/live': typeof LiveRouteWithChildren
  '/login': typeof LoginRoute
  '/partner': typeof PartnerRoute
  '/poker': typeof PokerRoute
  '/profile': typeof ProfileRouteWithChildren
  '/promotions': typeof PromotionsRouteWithChildren
  '/register': typeof RegisterRouteWithChildren
  '/resetpassword': typeof ResetpasswordRouteWithChildren
  '/results': typeof ResultsRoute
  '/sports': typeof SportsRouteWithChildren
  '/ui-kit': typeof UiKitRoute
  '/virtualsports': typeof VirtualsportsRoute
  '/casino/$category': typeof CasinoCategoryRouteWithChildren
  '/casino/providers': typeof CasinoProvidersRoute
  '/live/$eventId': typeof LiveEventIdRoute
  '/page/$slug': typeof PageSlugRoute
  '/profile/bonuses': typeof ProfileBonusesRouteWithChildren
  '/profile/claimbonus': typeof ProfileClaimbonusRoute
  '/profile/deposit-limits': typeof ProfileDepositLimitsRoute
  '/profile/deposits': typeof ProfileDepositsRouteWithChildren
  '/profile/details': typeof ProfileDetailsRoute
  '/profile/kyc': typeof ProfileKycRoute
  '/profile/messages': typeof ProfileMessagesRouteWithChildren
  '/profile/self-exclusion': typeof ProfileSelfExclusionRoute
  '/profile/settings': typeof ProfileSettingsRoute
  '/profile/tickets': typeof ProfileTicketsRoute
  '/profile/transactions': typeof ProfileTransactionsRoute
  '/profile/withdrawals': typeof ProfileWithdrawalsRouteWithChildren
  '/promotions/$slug': typeof PromotionsSlugRoute
  '/resetpassword/$guid': typeof ResetpasswordGuidRouteWithChildren
  '/verifyemail/$token': typeof VerifyemailTokenRoute
  '/casino/': typeof CasinoIndexRoute
  '/live/': typeof LiveIndexRoute
  '/livecasino/': typeof LivecasinoIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/promotions/': typeof PromotionsIndexRoute
  '/register/': typeof RegisterIndexRoute
  '/resetpassword/': typeof ResetpasswordIndexRoute
  '/sports/': typeof SportsIndexRoute
  '/casino/$category/$vendor': typeof CasinoCategoryVendorRoute
  '/profile/deposits/$providerId': typeof ProfileDepositsProviderIdRoute
  '/profile/messages/$messageId': typeof ProfileMessagesMessageIdRoute
  '/profile/withdrawals/$providerId': typeof ProfileWithdrawalsProviderIdRoute
  '/register/$item/$token': typeof RegisterItemTokenRoute
  '/resetpassword/$guid/$channel': typeof ResetpasswordGuidChannelRoute
  '/sports/$sport/favorites': typeof SportsSportFavoritesRoute
  '/sports/$sport/lastminute': typeof SportsSportLastminuteRoute
  '/sports/$sport/today': typeof SportsSportTodayRoute
  '/sports/$sport/topevents': typeof SportsSportTopeventsRoute
  '/casino/$category/': typeof CasinoCategoryIndexRoute
  '/profile/bonuses/': typeof ProfileBonusesIndexRoute
  '/profile/deposits/': typeof ProfileDepositsIndexRoute
  '/profile/messages/': typeof ProfileMessagesIndexRoute
  '/profile/withdrawals/': typeof ProfileWithdrawalsIndexRoute
  '/resetpassword/$guid/': typeof ResetpasswordGuidIndexRoute
  '/sports/$sport/': typeof SportsSportIndexRoute
  '/profile/bonuses/$bonusType/$bonusId': typeof ProfileBonusesBonusTypeBonusIdRoute
  '/sports/$sport/$category/': typeof SportsSportCategoryIndexRoute
  '/casino/$category/$provider/$vendor/$gameTag': typeof CasinoCategoryProviderVendorGameTagRouteWithChildren
  '/sports/$sport/$category/$tournament/$eventId': typeof SportsSportCategoryTournamentEventIdRoute
  '/sports/$sport/$category/$tournament/outrights': typeof SportsSportCategoryTournamentOutrightsRoute
  '/sports/$sport/$category/$tournament/': typeof SportsSportCategoryTournamentIndexRoute
  '/casino/$category/$provider/$vendor/$gameTag/$name': typeof CasinoCategoryProviderVendorGameTagNameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/betslip'
    | '/betzone'
    | '/bookedticket'
    | '/casino'
    | '/forgotpassword'
    | '/live'
    | '/login'
    | '/partner'
    | '/poker'
    | '/profile'
    | '/promotions'
    | '/register'
    | '/resetpassword'
    | '/results'
    | '/sports'
    | '/ui-kit'
    | '/virtualsports'
    | '/casino/$category'
    | '/casino/providers'
    | '/live/$eventId'
    | '/page/$slug'
    | '/profile/bonuses'
    | '/profile/claimbonus'
    | '/profile/deposit-limits'
    | '/profile/deposits'
    | '/profile/details'
    | '/profile/kyc'
    | '/profile/messages'
    | '/profile/self-exclusion'
    | '/profile/settings'
    | '/profile/tickets'
    | '/profile/transactions'
    | '/profile/withdrawals'
    | '/promotions/$slug'
    | '/resetpassword/$guid'
    | '/verifyemail/$token'
    | '/casino/'
    | '/live/'
    | '/livecasino/'
    | '/profile/'
    | '/promotions/'
    | '/register/'
    | '/resetpassword/'
    | '/sports/'
    | '/casino/$category/$vendor'
    | '/profile/deposits/$providerId'
    | '/profile/messages/$messageId'
    | '/profile/withdrawals/$providerId'
    | '/register/$item/$token'
    | '/resetpassword/$guid/$channel'
    | '/sports/$sport/favorites'
    | '/sports/$sport/lastminute'
    | '/sports/$sport/today'
    | '/sports/$sport/topevents'
    | '/casino/$category/'
    | '/profile/bonuses/'
    | '/profile/deposits/'
    | '/profile/messages/'
    | '/profile/withdrawals/'
    | '/resetpassword/$guid/'
    | '/sports/$sport/'
    | '/profile/bonuses/$bonusType/$bonusId'
    | '/sports/$sport/$category/'
    | '/casino/$category/$provider/$vendor/$gameTag'
    | '/sports/$sport/$category/$tournament/$eventId'
    | '/sports/$sport/$category/$tournament/outrights'
    | '/sports/$sport/$category/$tournament/'
    | '/casino/$category/$provider/$vendor/$gameTag/$name'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/betslip'
    | '/betzone'
    | '/bookedticket'
    | '/forgotpassword'
    | '/login'
    | '/partner'
    | '/poker'
    | '/results'
    | '/ui-kit'
    | '/virtualsports'
    | '/casino/providers'
    | '/live/$eventId'
    | '/page/$slug'
    | '/profile/claimbonus'
    | '/profile/deposit-limits'
    | '/profile/details'
    | '/profile/kyc'
    | '/profile/self-exclusion'
    | '/profile/settings'
    | '/profile/tickets'
    | '/profile/transactions'
    | '/promotions/$slug'
    | '/verifyemail/$token'
    | '/casino'
    | '/live'
    | '/livecasino'
    | '/profile'
    | '/promotions'
    | '/register'
    | '/resetpassword'
    | '/sports'
    | '/casino/$category/$vendor'
    | '/profile/deposits/$providerId'
    | '/profile/messages/$messageId'
    | '/profile/withdrawals/$providerId'
    | '/register/$item/$token'
    | '/resetpassword/$guid/$channel'
    | '/sports/$sport/favorites'
    | '/sports/$sport/lastminute'
    | '/sports/$sport/today'
    | '/sports/$sport/topevents'
    | '/casino/$category'
    | '/profile/bonuses'
    | '/profile/deposits'
    | '/profile/messages'
    | '/profile/withdrawals'
    | '/resetpassword/$guid'
    | '/sports/$sport'
    | '/profile/bonuses/$bonusType/$bonusId'
    | '/sports/$sport/$category'
    | '/casino/$category/$provider/$vendor/$gameTag'
    | '/sports/$sport/$category/$tournament/$eventId'
    | '/sports/$sport/$category/$tournament/outrights'
    | '/sports/$sport/$category/$tournament'
    | '/casino/$category/$provider/$vendor/$gameTag/$name'
  id:
    | '__root__'
    | '/'
    | '/betslip'
    | '/betzone'
    | '/bookedticket'
    | '/casino'
    | '/forgotpassword'
    | '/live'
    | '/login'
    | '/partner'
    | '/poker'
    | '/profile'
    | '/promotions'
    | '/register'
    | '/resetpassword'
    | '/results'
    | '/sports'
    | '/ui-kit'
    | '/virtualsports'
    | '/casino/$category'
    | '/casino/providers'
    | '/live/$eventId'
    | '/page/$slug'
    | '/profile/bonuses'
    | '/profile/claimbonus'
    | '/profile/deposit-limits'
    | '/profile/deposits'
    | '/profile/details'
    | '/profile/kyc'
    | '/profile/messages'
    | '/profile/self-exclusion'
    | '/profile/settings'
    | '/profile/tickets'
    | '/profile/transactions'
    | '/profile/withdrawals'
    | '/promotions/$slug'
    | '/resetpassword/$guid'
    | '/verifyemail/$token'
    | '/casino/'
    | '/live/'
    | '/livecasino/'
    | '/profile/'
    | '/promotions/'
    | '/register/'
    | '/resetpassword/'
    | '/sports/'
    | '/casino/$category/$vendor'
    | '/profile/deposits/$providerId'
    | '/profile/messages/$messageId'
    | '/profile/withdrawals/$providerId'
    | '/register/$item/$token'
    | '/resetpassword/$guid/$channel'
    | '/sports/$sport/favorites'
    | '/sports/$sport/lastminute'
    | '/sports/$sport/today'
    | '/sports/$sport/topevents'
    | '/casino/$category/'
    | '/profile/bonuses/'
    | '/profile/deposits/'
    | '/profile/messages/'
    | '/profile/withdrawals/'
    | '/resetpassword/$guid/'
    | '/sports/$sport/'
    | '/profile/bonuses/$bonusType/$bonusId'
    | '/sports/$sport/$category/'
    | '/casino/$category/$provider/$vendor/$gameTag'
    | '/sports/$sport/$category/$tournament/$eventId'
    | '/sports/$sport/$category/$tournament/outrights'
    | '/sports/$sport/$category/$tournament/'
    | '/casino/$category/$provider/$vendor/$gameTag/$name'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BetslipRoute: typeof BetslipRoute
  BetzoneRoute: typeof BetzoneRoute
  BookedticketRoute: typeof BookedticketRoute
  CasinoRoute: typeof CasinoRouteWithChildren
  ForgotpasswordRoute: typeof ForgotpasswordRoute
  LiveRoute: typeof LiveRouteWithChildren
  LoginRoute: typeof LoginRoute
  PartnerRoute: typeof PartnerRoute
  PokerRoute: typeof PokerRoute
  ProfileRoute: typeof ProfileRouteWithChildren
  PromotionsRoute: typeof PromotionsRouteWithChildren
  RegisterRoute: typeof RegisterRouteWithChildren
  ResetpasswordRoute: typeof ResetpasswordRouteWithChildren
  ResultsRoute: typeof ResultsRoute
  SportsRoute: typeof SportsRouteWithChildren
  UiKitRoute: typeof UiKitRoute
  VirtualsportsRoute: typeof VirtualsportsRoute
  PageSlugRoute: typeof PageSlugRoute
  VerifyemailTokenRoute: typeof VerifyemailTokenRoute
  LivecasinoIndexRoute: typeof LivecasinoIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/betslip': {
      id: '/betslip'
      path: '/betslip'
      fullPath: '/betslip'
      preLoaderRoute: typeof BetslipRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/betzone': {
      id: '/betzone'
      path: '/betzone'
      fullPath: '/betzone'
      preLoaderRoute: typeof BetzoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookedticket': {
      id: '/bookedticket'
      path: '/bookedticket'
      fullPath: '/bookedticket'
      preLoaderRoute: typeof BookedticketRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/casino': {
      id: '/casino'
      path: '/casino'
      fullPath: '/casino'
      preLoaderRoute: typeof CasinoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgotpassword': {
      id: '/forgotpassword'
      path: '/forgotpassword'
      fullPath: '/forgotpassword'
      preLoaderRoute: typeof ForgotpasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live': {
      id: '/live'
      path: '/live'
      fullPath: '/live'
      preLoaderRoute: typeof LiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner': {
      id: '/partner'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof PartnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/poker': {
      id: '/poker'
      path: '/poker'
      fullPath: '/poker'
      preLoaderRoute: typeof PokerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/promotions': {
      id: '/promotions'
      path: '/promotions'
      fullPath: '/promotions'
      preLoaderRoute: typeof PromotionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resetpassword': {
      id: '/resetpassword'
      path: '/resetpassword'
      fullPath: '/resetpassword'
      preLoaderRoute: typeof ResetpasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/results': {
      id: '/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof ResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sports': {
      id: '/sports'
      path: '/sports'
      fullPath: '/sports'
      preLoaderRoute: typeof SportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ui-kit': {
      id: '/ui-kit'
      path: '/ui-kit'
      fullPath: '/ui-kit'
      preLoaderRoute: typeof UiKitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/virtualsports': {
      id: '/virtualsports'
      path: '/virtualsports'
      fullPath: '/virtualsports'
      preLoaderRoute: typeof VirtualsportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/casino/': {
      id: '/casino/'
      path: '/'
      fullPath: '/casino/'
      preLoaderRoute: typeof CasinoIndexRouteImport
      parentRoute: typeof CasinoRoute
    }
    '/casino/$category': {
      id: '/casino/$category'
      path: '/$category'
      fullPath: '/casino/$category'
      preLoaderRoute: typeof CasinoCategoryRouteImport
      parentRoute: typeof CasinoRoute
    }
    '/casino/providers': {
      id: '/casino/providers'
      path: '/providers'
      fullPath: '/casino/providers'
      preLoaderRoute: typeof CasinoProvidersRouteImport
      parentRoute: typeof CasinoRoute
    }
    '/live/': {
      id: '/live/'
      path: '/'
      fullPath: '/live/'
      preLoaderRoute: typeof LiveIndexRouteImport
      parentRoute: typeof LiveRoute
    }
    '/live/$eventId': {
      id: '/live/$eventId'
      path: '/$eventId'
      fullPath: '/live/$eventId'
      preLoaderRoute: typeof LiveEventIdRouteImport
      parentRoute: typeof LiveRoute
    }
    '/livecasino/': {
      id: '/livecasino/'
      path: '/livecasino'
      fullPath: '/livecasino/'
      preLoaderRoute: typeof LivecasinoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/page/$slug': {
      id: '/page/$slug'
      path: '/page/$slug'
      fullPath: '/page/$slug'
      preLoaderRoute: typeof PageSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/bonuses': {
      id: '/profile/bonuses'
      path: '/bonuses'
      fullPath: '/profile/bonuses'
      preLoaderRoute: typeof ProfileBonusesRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/claimbonus': {
      id: '/profile/claimbonus'
      path: '/claimbonus'
      fullPath: '/profile/claimbonus'
      preLoaderRoute: typeof ProfileClaimbonusRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/deposit-limits': {
      id: '/profile/deposit-limits'
      path: '/deposit-limits'
      fullPath: '/profile/deposit-limits'
      preLoaderRoute: typeof ProfileDepositLimitsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/deposits': {
      id: '/profile/deposits'
      path: '/deposits'
      fullPath: '/profile/deposits'
      preLoaderRoute: typeof ProfileDepositsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/details': {
      id: '/profile/details'
      path: '/details'
      fullPath: '/profile/details'
      preLoaderRoute: typeof ProfileDetailsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/kyc': {
      id: '/profile/kyc'
      path: '/kyc'
      fullPath: '/profile/kyc'
      preLoaderRoute: typeof ProfileKycRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/messages': {
      id: '/profile/messages'
      path: '/messages'
      fullPath: '/profile/messages'
      preLoaderRoute: typeof ProfileMessagesRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/self-exclusion': {
      id: '/profile/self-exclusion'
      path: '/self-exclusion'
      fullPath: '/profile/self-exclusion'
      preLoaderRoute: typeof ProfileSelfExclusionRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/settings': {
      id: '/profile/settings'
      path: '/settings'
      fullPath: '/profile/settings'
      preLoaderRoute: typeof ProfileSettingsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/tickets': {
      id: '/profile/tickets'
      path: '/tickets'
      fullPath: '/profile/tickets'
      preLoaderRoute: typeof ProfileTicketsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/transactions': {
      id: '/profile/transactions'
      path: '/transactions'
      fullPath: '/profile/transactions'
      preLoaderRoute: typeof ProfileTransactionsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/withdrawals': {
      id: '/profile/withdrawals'
      path: '/withdrawals'
      fullPath: '/profile/withdrawals'
      preLoaderRoute: typeof ProfileWithdrawalsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/promotions/': {
      id: '/promotions/'
      path: '/'
      fullPath: '/promotions/'
      preLoaderRoute: typeof PromotionsIndexRouteImport
      parentRoute: typeof PromotionsRoute
    }
    '/promotions/$slug': {
      id: '/promotions/$slug'
      path: '/$slug'
      fullPath: '/promotions/$slug'
      preLoaderRoute: typeof PromotionsSlugRouteImport
      parentRoute: typeof PromotionsRoute
    }
    '/register/': {
      id: '/register/'
      path: '/'
      fullPath: '/register/'
      preLoaderRoute: typeof RegisterIndexRouteImport
      parentRoute: typeof RegisterRoute
    }
    '/resetpassword/': {
      id: '/resetpassword/'
      path: '/'
      fullPath: '/resetpassword/'
      preLoaderRoute: typeof ResetpasswordIndexRouteImport
      parentRoute: typeof ResetpasswordRoute
    }
    '/resetpassword/$guid': {
      id: '/resetpassword/$guid'
      path: '/$guid'
      fullPath: '/resetpassword/$guid'
      preLoaderRoute: typeof ResetpasswordGuidRouteImport
      parentRoute: typeof ResetpasswordRoute
    }
    '/sports/': {
      id: '/sports/'
      path: '/'
      fullPath: '/sports/'
      preLoaderRoute: typeof SportsIndexRouteImport
      parentRoute: typeof SportsRoute
    }
    '/verifyemail/$token': {
      id: '/verifyemail/$token'
      path: '/verifyemail/$token'
      fullPath: '/verifyemail/$token'
      preLoaderRoute: typeof VerifyemailTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/casino/$category/': {
      id: '/casino/$category/'
      path: '/'
      fullPath: '/casino/$category/'
      preLoaderRoute: typeof CasinoCategoryIndexRouteImport
      parentRoute: typeof CasinoCategoryRoute
    }
    '/casino/$category/$vendor': {
      id: '/casino/$category/$vendor'
      path: '/$vendor'
      fullPath: '/casino/$category/$vendor'
      preLoaderRoute: typeof CasinoCategoryVendorRouteImport
      parentRoute: typeof CasinoCategoryRoute
    }
    '/profile/bonuses/': {
      id: '/profile/bonuses/'
      path: '/'
      fullPath: '/profile/bonuses/'
      preLoaderRoute: typeof ProfileBonusesIndexRouteImport
      parentRoute: typeof ProfileBonusesRoute
    }
    '/profile/deposits/': {
      id: '/profile/deposits/'
      path: '/'
      fullPath: '/profile/deposits/'
      preLoaderRoute: typeof ProfileDepositsIndexRouteImport
      parentRoute: typeof ProfileDepositsRoute
    }
    '/profile/deposits/$providerId': {
      id: '/profile/deposits/$providerId'
      path: '/$providerId'
      fullPath: '/profile/deposits/$providerId'
      preLoaderRoute: typeof ProfileDepositsProviderIdRouteImport
      parentRoute: typeof ProfileDepositsRoute
    }
    '/profile/messages/': {
      id: '/profile/messages/'
      path: '/'
      fullPath: '/profile/messages/'
      preLoaderRoute: typeof ProfileMessagesIndexRouteImport
      parentRoute: typeof ProfileMessagesRoute
    }
    '/profile/messages/$messageId': {
      id: '/profile/messages/$messageId'
      path: '/$messageId'
      fullPath: '/profile/messages/$messageId'
      preLoaderRoute: typeof ProfileMessagesMessageIdRouteImport
      parentRoute: typeof ProfileMessagesRoute
    }
    '/profile/withdrawals/': {
      id: '/profile/withdrawals/'
      path: '/'
      fullPath: '/profile/withdrawals/'
      preLoaderRoute: typeof ProfileWithdrawalsIndexRouteImport
      parentRoute: typeof ProfileWithdrawalsRoute
    }
    '/profile/withdrawals/$providerId': {
      id: '/profile/withdrawals/$providerId'
      path: '/$providerId'
      fullPath: '/profile/withdrawals/$providerId'
      preLoaderRoute: typeof ProfileWithdrawalsProviderIdRouteImport
      parentRoute: typeof ProfileWithdrawalsRoute
    }
    '/register/$item/$token': {
      id: '/register/$item/$token'
      path: '/$item/$token'
      fullPath: '/register/$item/$token'
      preLoaderRoute: typeof RegisterItemTokenRouteImport
      parentRoute: typeof RegisterRoute
    }
    '/resetpassword/$guid/': {
      id: '/resetpassword/$guid/'
      path: '/'
      fullPath: '/resetpassword/$guid/'
      preLoaderRoute: typeof ResetpasswordGuidIndexRouteImport
      parentRoute: typeof ResetpasswordGuidRoute
    }
    '/resetpassword/$guid/$channel': {
      id: '/resetpassword/$guid/$channel'
      path: '/$channel'
      fullPath: '/resetpassword/$guid/$channel'
      preLoaderRoute: typeof ResetpasswordGuidChannelRouteImport
      parentRoute: typeof ResetpasswordGuidRoute
    }
    '/sports/$sport/': {
      id: '/sports/$sport/'
      path: '/$sport'
      fullPath: '/sports/$sport/'
      preLoaderRoute: typeof SportsSportIndexRouteImport
      parentRoute: typeof SportsRoute
    }
    '/sports/$sport/favorites': {
      id: '/sports/$sport/favorites'
      path: '/$sport/favorites'
      fullPath: '/sports/$sport/favorites'
      preLoaderRoute: typeof SportsSportFavoritesRouteImport
      parentRoute: typeof SportsRoute
    }
    '/sports/$sport/lastminute': {
      id: '/sports/$sport/lastminute'
      path: '/$sport/lastminute'
      fullPath: '/sports/$sport/lastminute'
      preLoaderRoute: typeof SportsSportLastminuteRouteImport
      parentRoute: typeof SportsRoute
    }
    '/sports/$sport/today': {
      id: '/sports/$sport/today'
      path: '/$sport/today'
      fullPath: '/sports/$sport/today'
      preLoaderRoute: typeof SportsSportTodayRouteImport
      parentRoute: typeof SportsRoute
    }
    '/sports/$sport/topevents': {
      id: '/sports/$sport/topevents'
      path: '/$sport/topevents'
      fullPath: '/sports/$sport/topevents'
      preLoaderRoute: typeof SportsSportTopeventsRouteImport
      parentRoute: typeof SportsRoute
    }
    '/profile/bonuses/$bonusType/$bonusId': {
      id: '/profile/bonuses/$bonusType/$bonusId'
      path: '/$bonusType/$bonusId'
      fullPath: '/profile/bonuses/$bonusType/$bonusId'
      preLoaderRoute: typeof ProfileBonusesBonusTypeBonusIdRouteImport
      parentRoute: typeof ProfileBonusesRoute
    }
    '/sports/$sport/$category/': {
      id: '/sports/$sport/$category/'
      path: '/$sport/$category'
      fullPath: '/sports/$sport/$category/'
      preLoaderRoute: typeof SportsSportCategoryIndexRouteImport
      parentRoute: typeof SportsRoute
    }
    '/casino/$category/$provider/$vendor/$gameTag': {
      id: '/casino/$category/$provider/$vendor/$gameTag'
      path: '/$provider/$vendor/$gameTag'
      fullPath: '/casino/$category/$provider/$vendor/$gameTag'
      preLoaderRoute: typeof CasinoCategoryProviderVendorGameTagRouteImport
      parentRoute: typeof CasinoCategoryRoute
    }
    '/sports/$sport/$category/$tournament/': {
      id: '/sports/$sport/$category/$tournament/'
      path: '/$sport/$category/$tournament'
      fullPath: '/sports/$sport/$category/$tournament/'
      preLoaderRoute: typeof SportsSportCategoryTournamentIndexRouteImport
      parentRoute: typeof SportsRoute
    }
    '/sports/$sport/$category/$tournament/$eventId': {
      id: '/sports/$sport/$category/$tournament/$eventId'
      path: '/$sport/$category/$tournament/$eventId'
      fullPath: '/sports/$sport/$category/$tournament/$eventId'
      preLoaderRoute: typeof SportsSportCategoryTournamentEventIdRouteImport
      parentRoute: typeof SportsRoute
    }
    '/sports/$sport/$category/$tournament/outrights': {
      id: '/sports/$sport/$category/$tournament/outrights'
      path: '/$sport/$category/$tournament/outrights'
      fullPath: '/sports/$sport/$category/$tournament/outrights'
      preLoaderRoute: typeof SportsSportCategoryTournamentOutrightsRouteImport
      parentRoute: typeof SportsRoute
    }
    '/casino/$category/$provider/$vendor/$gameTag/$name': {
      id: '/casino/$category/$provider/$vendor/$gameTag/$name'
      path: '/$name'
      fullPath: '/casino/$category/$provider/$vendor/$gameTag/$name'
      preLoaderRoute: typeof CasinoCategoryProviderVendorGameTagNameRouteImport
      parentRoute: typeof CasinoCategoryProviderVendorGameTagRoute
    }
  }
}

interface CasinoCategoryProviderVendorGameTagRouteChildren {
  CasinoCategoryProviderVendorGameTagNameRoute: typeof CasinoCategoryProviderVendorGameTagNameRoute
}

const CasinoCategoryProviderVendorGameTagRouteChildren: CasinoCategoryProviderVendorGameTagRouteChildren =
  {
    CasinoCategoryProviderVendorGameTagNameRoute:
      CasinoCategoryProviderVendorGameTagNameRoute,
  }

const CasinoCategoryProviderVendorGameTagRouteWithChildren =
  CasinoCategoryProviderVendorGameTagRoute._addFileChildren(
    CasinoCategoryProviderVendorGameTagRouteChildren,
  )

interface CasinoCategoryRouteChildren {
  CasinoCategoryVendorRoute: typeof CasinoCategoryVendorRoute
  CasinoCategoryIndexRoute: typeof CasinoCategoryIndexRoute
  CasinoCategoryProviderVendorGameTagRoute: typeof CasinoCategoryProviderVendorGameTagRouteWithChildren
}

const CasinoCategoryRouteChildren: CasinoCategoryRouteChildren = {
  CasinoCategoryVendorRoute: CasinoCategoryVendorRoute,
  CasinoCategoryIndexRoute: CasinoCategoryIndexRoute,
  CasinoCategoryProviderVendorGameTagRoute:
    CasinoCategoryProviderVendorGameTagRouteWithChildren,
}

const CasinoCategoryRouteWithChildren = CasinoCategoryRoute._addFileChildren(
  CasinoCategoryRouteChildren,
)

interface CasinoRouteChildren {
  CasinoCategoryRoute: typeof CasinoCategoryRouteWithChildren
  CasinoProvidersRoute: typeof CasinoProvidersRoute
  CasinoIndexRoute: typeof CasinoIndexRoute
}

const CasinoRouteChildren: CasinoRouteChildren = {
  CasinoCategoryRoute: CasinoCategoryRouteWithChildren,
  CasinoProvidersRoute: CasinoProvidersRoute,
  CasinoIndexRoute: CasinoIndexRoute,
}

const CasinoRouteWithChildren =
  CasinoRoute._addFileChildren(CasinoRouteChildren)

interface LiveRouteChildren {
  LiveEventIdRoute: typeof LiveEventIdRoute
  LiveIndexRoute: typeof LiveIndexRoute
}

const LiveRouteChildren: LiveRouteChildren = {
  LiveEventIdRoute: LiveEventIdRoute,
  LiveIndexRoute: LiveIndexRoute,
}

const LiveRouteWithChildren = LiveRoute._addFileChildren(LiveRouteChildren)

interface ProfileBonusesRouteChildren {
  ProfileBonusesIndexRoute: typeof ProfileBonusesIndexRoute
  ProfileBonusesBonusTypeBonusIdRoute: typeof ProfileBonusesBonusTypeBonusIdRoute
}

const ProfileBonusesRouteChildren: ProfileBonusesRouteChildren = {
  ProfileBonusesIndexRoute: ProfileBonusesIndexRoute,
  ProfileBonusesBonusTypeBonusIdRoute: ProfileBonusesBonusTypeBonusIdRoute,
}

const ProfileBonusesRouteWithChildren = ProfileBonusesRoute._addFileChildren(
  ProfileBonusesRouteChildren,
)

interface ProfileDepositsRouteChildren {
  ProfileDepositsProviderIdRoute: typeof ProfileDepositsProviderIdRoute
  ProfileDepositsIndexRoute: typeof ProfileDepositsIndexRoute
}

const ProfileDepositsRouteChildren: ProfileDepositsRouteChildren = {
  ProfileDepositsProviderIdRoute: ProfileDepositsProviderIdRoute,
  ProfileDepositsIndexRoute: ProfileDepositsIndexRoute,
}

const ProfileDepositsRouteWithChildren = ProfileDepositsRoute._addFileChildren(
  ProfileDepositsRouteChildren,
)

interface ProfileMessagesRouteChildren {
  ProfileMessagesMessageIdRoute: typeof ProfileMessagesMessageIdRoute
  ProfileMessagesIndexRoute: typeof ProfileMessagesIndexRoute
}

const ProfileMessagesRouteChildren: ProfileMessagesRouteChildren = {
  ProfileMessagesMessageIdRoute: ProfileMessagesMessageIdRoute,
  ProfileMessagesIndexRoute: ProfileMessagesIndexRoute,
}

const ProfileMessagesRouteWithChildren = ProfileMessagesRoute._addFileChildren(
  ProfileMessagesRouteChildren,
)

interface ProfileWithdrawalsRouteChildren {
  ProfileWithdrawalsProviderIdRoute: typeof ProfileWithdrawalsProviderIdRoute
  ProfileWithdrawalsIndexRoute: typeof ProfileWithdrawalsIndexRoute
}

const ProfileWithdrawalsRouteChildren: ProfileWithdrawalsRouteChildren = {
  ProfileWithdrawalsProviderIdRoute: ProfileWithdrawalsProviderIdRoute,
  ProfileWithdrawalsIndexRoute: ProfileWithdrawalsIndexRoute,
}

const ProfileWithdrawalsRouteWithChildren =
  ProfileWithdrawalsRoute._addFileChildren(ProfileWithdrawalsRouteChildren)

interface ProfileRouteChildren {
  ProfileBonusesRoute: typeof ProfileBonusesRouteWithChildren
  ProfileClaimbonusRoute: typeof ProfileClaimbonusRoute
  ProfileDepositLimitsRoute: typeof ProfileDepositLimitsRoute
  ProfileDepositsRoute: typeof ProfileDepositsRouteWithChildren
  ProfileDetailsRoute: typeof ProfileDetailsRoute
  ProfileKycRoute: typeof ProfileKycRoute
  ProfileMessagesRoute: typeof ProfileMessagesRouteWithChildren
  ProfileSelfExclusionRoute: typeof ProfileSelfExclusionRoute
  ProfileSettingsRoute: typeof ProfileSettingsRoute
  ProfileTicketsRoute: typeof ProfileTicketsRoute
  ProfileTransactionsRoute: typeof ProfileTransactionsRoute
  ProfileWithdrawalsRoute: typeof ProfileWithdrawalsRouteWithChildren
  ProfileIndexRoute: typeof ProfileIndexRoute
}

const ProfileRouteChildren: ProfileRouteChildren = {
  ProfileBonusesRoute: ProfileBonusesRouteWithChildren,
  ProfileClaimbonusRoute: ProfileClaimbonusRoute,
  ProfileDepositLimitsRoute: ProfileDepositLimitsRoute,
  ProfileDepositsRoute: ProfileDepositsRouteWithChildren,
  ProfileDetailsRoute: ProfileDetailsRoute,
  ProfileKycRoute: ProfileKycRoute,
  ProfileMessagesRoute: ProfileMessagesRouteWithChildren,
  ProfileSelfExclusionRoute: ProfileSelfExclusionRoute,
  ProfileSettingsRoute: ProfileSettingsRoute,
  ProfileTicketsRoute: ProfileTicketsRoute,
  ProfileTransactionsRoute: ProfileTransactionsRoute,
  ProfileWithdrawalsRoute: ProfileWithdrawalsRouteWithChildren,
  ProfileIndexRoute: ProfileIndexRoute,
}

const ProfileRouteWithChildren =
  ProfileRoute._addFileChildren(ProfileRouteChildren)

interface PromotionsRouteChildren {
  PromotionsSlugRoute: typeof PromotionsSlugRoute
  PromotionsIndexRoute: typeof PromotionsIndexRoute
}

const PromotionsRouteChildren: PromotionsRouteChildren = {
  PromotionsSlugRoute: PromotionsSlugRoute,
  PromotionsIndexRoute: PromotionsIndexRoute,
}

const PromotionsRouteWithChildren = PromotionsRoute._addFileChildren(
  PromotionsRouteChildren,
)

interface RegisterRouteChildren {
  RegisterIndexRoute: typeof RegisterIndexRoute
  RegisterItemTokenRoute: typeof RegisterItemTokenRoute
}

const RegisterRouteChildren: RegisterRouteChildren = {
  RegisterIndexRoute: RegisterIndexRoute,
  RegisterItemTokenRoute: RegisterItemTokenRoute,
}

const RegisterRouteWithChildren = RegisterRoute._addFileChildren(
  RegisterRouteChildren,
)

interface ResetpasswordGuidRouteChildren {
  ResetpasswordGuidChannelRoute: typeof ResetpasswordGuidChannelRoute
  ResetpasswordGuidIndexRoute: typeof ResetpasswordGuidIndexRoute
}

const ResetpasswordGuidRouteChildren: ResetpasswordGuidRouteChildren = {
  ResetpasswordGuidChannelRoute: ResetpasswordGuidChannelRoute,
  ResetpasswordGuidIndexRoute: ResetpasswordGuidIndexRoute,
}

const ResetpasswordGuidRouteWithChildren =
  ResetpasswordGuidRoute._addFileChildren(ResetpasswordGuidRouteChildren)

interface ResetpasswordRouteChildren {
  ResetpasswordGuidRoute: typeof ResetpasswordGuidRouteWithChildren
  ResetpasswordIndexRoute: typeof ResetpasswordIndexRoute
}

const ResetpasswordRouteChildren: ResetpasswordRouteChildren = {
  ResetpasswordGuidRoute: ResetpasswordGuidRouteWithChildren,
  ResetpasswordIndexRoute: ResetpasswordIndexRoute,
}

const ResetpasswordRouteWithChildren = ResetpasswordRoute._addFileChildren(
  ResetpasswordRouteChildren,
)

interface SportsRouteChildren {
  SportsIndexRoute: typeof SportsIndexRoute
  SportsSportFavoritesRoute: typeof SportsSportFavoritesRoute
  SportsSportLastminuteRoute: typeof SportsSportLastminuteRoute
  SportsSportTodayRoute: typeof SportsSportTodayRoute
  SportsSportTopeventsRoute: typeof SportsSportTopeventsRoute
  SportsSportIndexRoute: typeof SportsSportIndexRoute
  SportsSportCategoryIndexRoute: typeof SportsSportCategoryIndexRoute
  SportsSportCategoryTournamentEventIdRoute: typeof SportsSportCategoryTournamentEventIdRoute
  SportsSportCategoryTournamentOutrightsRoute: typeof SportsSportCategoryTournamentOutrightsRoute
  SportsSportCategoryTournamentIndexRoute: typeof SportsSportCategoryTournamentIndexRoute
}

const SportsRouteChildren: SportsRouteChildren = {
  SportsIndexRoute: SportsIndexRoute,
  SportsSportFavoritesRoute: SportsSportFavoritesRoute,
  SportsSportLastminuteRoute: SportsSportLastminuteRoute,
  SportsSportTodayRoute: SportsSportTodayRoute,
  SportsSportTopeventsRoute: SportsSportTopeventsRoute,
  SportsSportIndexRoute: SportsSportIndexRoute,
  SportsSportCategoryIndexRoute: SportsSportCategoryIndexRoute,
  SportsSportCategoryTournamentEventIdRoute:
    SportsSportCategoryTournamentEventIdRoute,
  SportsSportCategoryTournamentOutrightsRoute:
    SportsSportCategoryTournamentOutrightsRoute,
  SportsSportCategoryTournamentIndexRoute:
    SportsSportCategoryTournamentIndexRoute,
}

const SportsRouteWithChildren =
  SportsRoute._addFileChildren(SportsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BetslipRoute: BetslipRoute,
  BetzoneRoute: BetzoneRoute,
  BookedticketRoute: BookedticketRoute,
  CasinoRoute: CasinoRouteWithChildren,
  ForgotpasswordRoute: ForgotpasswordRoute,
  LiveRoute: LiveRouteWithChildren,
  LoginRoute: LoginRoute,
  PartnerRoute: PartnerRoute,
  PokerRoute: PokerRoute,
  ProfileRoute: ProfileRouteWithChildren,
  PromotionsRoute: PromotionsRouteWithChildren,
  RegisterRoute: RegisterRouteWithChildren,
  ResetpasswordRoute: ResetpasswordRouteWithChildren,
  ResultsRoute: ResultsRoute,
  SportsRoute: SportsRouteWithChildren,
  UiKitRoute: UiKitRoute,
  VirtualsportsRoute: VirtualsportsRoute,
  PageSlugRoute: PageSlugRoute,
  VerifyemailTokenRoute: VerifyemailTokenRoute,
  LivecasinoIndexRoute: LivecasinoIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
